<template>
  <v-container id="fdi-dialog-component" pt-0 pb-3 px-0>
    <v-container id="fdi-dialog-container" mt-1 align-center justify-center d-flex pa-0>
      <v-layout column>
        <v-layout row d-flex align-end justify-end>
          <v-flex xs3 mr-4>
            <v-img id="arrow" :src="forwardArrow"/>
          </v-flex>
        </v-layout>
        <v-layout row d-flex align-end justify-end>
          <v-flex d-flex align-end justify-end>
            <v-img
              transition="slide-x-reverse-transition"
              v-for="(url, i) in step.dialogUrls"
              :key="`forward-${i+1}`"
              v-if="i===currentDialogIndex && forward"
              :aspect-ratio="1080/972"
              position="center bottom"
              :src="url.url"
              contain
            ></v-img>
            <v-img
              transition="slide-x-transition"
              v-for="(url, i) in step.dialogUrls"
              :key="`back-${i+1}`"
              v-if="i===currentDialogIndex && !forward"
              :aspect-ratio="1080/972"
              position="center bottom"
              :src="url.url"
              contain
            ></v-img>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import forwardArrow from "@/assets/dialogComponent/arrow-forward.png";
export default {
  name: "fdi-dialog-component",
  props: {
    step: {
      type: Object,
      default: () => {}
    },
    currentDialogIndex: {
      type: Number,
      default: () => 0
    },
    forward: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    console.log(this.step);
  },
  data() {
    return {
      numOfDialogViews: this.step.dialogUrls.length,
      forwardArrow: forwardArrow
    };
  },
  computed: {},
  methods: {
    slidingTransitionCheck(to, from) {
      return to > from ? "slide-x-reverse-transition" : "slide-x-transition";
    },
    goBack() {
      this.$store.dispatch("decrementStep");
    },
    goForward() {
      this.$store.dispatch("incrementStep");
    },
    swipe(direction) {
      console.log("swiping", direction, this.numOfDialogViews);
      switch (direction) {
        case "right":
          if (this.currentDialogIndex === 0) {
            this.goBack();
          } else {
            this.forward = false;
            this.currentDialogIndex -= 1;
          }
          break;
        case "left":
          if (this.currentDialogIndex + 1 === this.numOfDialogViews) {
            this.goForward();
          } else {
            this.forward = true;
            this.currentDialogIndex += 1;
          }
          break;
      }
    }
  }
};
</script>

<style scoped>
#fdi-dialog-component {
  position: absolute;
  top: 110px;
  bottom: 0px;
}

#fdi-dialog-container {
  height: 80%;
}
</style>
